import { Box } from "@mui/material";
import "./_style.scss";
import { useContext, useEffect, useState } from "react";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import TkDataTable from "../../components/molecules/TkDataTable";
import { headList } from "./parts";
import { httpIAPI_APP016, httpIAPI_STA026 } from "./api/request";
import { infoBodyList } from "./hooks/useHooks";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkMemo from "../../components/molecules/TkMemo";
import { IAPI_APP016_Request } from "../../type/apiType";
import { InquiryCode } from "../../assets/data/Constants";

/**
 * SCRW060003 共済契約対象（外）施設等異動　対象者一覧
 * @return SCRW060003 共済契約対象（外）施設等異動　対象者一覧
 */
const SCRW060003 = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [bodyListData, setBodyListData] = useState<any>();
  const [businessType, setBusinessType] = useState<any>();
  const [status, setStatus] = useState<any>("");
  const [flowType, setFlowType] = useState<any>();
  const [corpApplyKbn, setCorpApplyKbn] = useState<any>();
  const [bodyList, setBodyList] = useState<any>();
  const [memoData, setMemoData] = useState("");
  const [memoCheck, setMemoCheck] = useState(false);
  const jobTypeName = String(
    businessState.common?.businessType?.toLowerCase().replace("-", "_")
  );
  const job_xx =
    jobTypeName && (businessState as Record<string, any>)[jobTypeName];

  const handelEntry = (item: any) => {
    switch (item.transferDateType) {
      case "1":
        setBusinessState({
          ...businessState,
          common: {
            ...businessState.common,
            businessType: "JOB-29",
          },
          job_29: {
            applyId: item?.applyId,
            staffNo: item?.staffNo,
          },
        });
        navigate("/SCRC060115");
        break;
      case "2":
        setBusinessState({
          ...businessState,
          common: {
            ...businessState.common,
            businessType: "JOB-28",
          },
          job_28: {
            applyId: item?.applyId,
            staffNo: item?.staffNo,
          },
        });
        navigate("/SCRC060114");
        break;
    }
  };

  const handelInit = async () => {
    try {
      const res = await httpIAPI_STA026({
        applyIdList: [{ applyId: location.state?.applyId ?? job_xx?.applyId }],
      });
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        const bodyListData: any = [];

        res.statusList?.forEach((item: any) => {
          const data = [
            { children: item?.managerName },
            { children: item?.process },
            { children: item?.createDate },
            { children: item?.processComment },
          ];
          bodyListData.push(data);
        });
        setBodyList(bodyListData);
        setStatus(res.latestApplyStatus);
        setCorpApplyKbn(res.corpApplyKbn);
        if (res?.staffList && res.staffList[0].transferDateType === "1") {
          setFlowType("TYPE3");
          setBusinessType("JOB-29");
        } else {
          setFlowType("TYPE4");
          setBusinessType("JOB-28");
        }
        setBodyListData(infoBodyList(res.staffList, handelEntry));
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handelInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const btnEvent = async (btnName: any) => {
    const num =
      btnName === "契約者に差戻し"
        ? "5"
        : btnName === "受理"
        ? "2"
        : btnName === "担当者に差戻し"
        ? "8"
        : btnName === "課長代理確認"
        ? "14"
        : btnName === "上長承認"
        ? "6"
        : null;
    if (num === null) {
      return;
    }

    let reqData: IAPI_APP016_Request = {
      applyId: location.state.applyId,
      applyEvent: num,
      contractorNo: businessState.common?.contractorNo,
      screenId: "SCRW060003",
      reason: memoData,
    };

    memoCheck && (reqData.inquiryCode = InquiryCode["職員"]);

    try {
      const res = await httpIAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const onChange = (event: any) => {
    switch (event.target.type) {
      case "input":
        setMemoData(event.target.value);
        break;
      case "checkbox":
        setMemoCheck(event.target.value);
        break;
    }
  };

  return (
    <Box className="SCRW060003" data-testid="SCRW060003PageForTest">
      <TkKikoStepper
        applicationFlowType={flowType}
        businessType={businessType}
        applicationStatus={status}
        corporateApplicationClassification={corpApplyKbn}
      />
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLW060003_01}</TkInfoManual>
      <TkContractorAndNumberLine
        name="契約者(法人)名"
        no={
          (businessState.common?.contractorNo ?? "") +
          ":" +
          (businessState.common?.contractorName ?? "")
        }
      />
      <TkDataTable headList={headList} bodyList={bodyListData} />
      <TkMemo
        showTable={true}
        bodyList={bodyList}
        onChange={onChange}
        disabledCheckBox={false}
      ></TkMemo>
      <Box className="buttonGroup">
        <TkBackButton mr />
        <TkViewButtonJudgement
          onClick={btnEvent}
          flowType={flowType}
          Status={status}
        />
      </Box>
    </Box>
  );
};

export default SCRW060003;
